import { createReducer, on } from '@ngrx/store';
import { ProfileTeamsActions } from '../../../profile/store/actions/actions-type.action';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';
import { Tournament } from '../../../tournament/models/tournaments.interface';
import { TeamTournamentsWithPagination } from '../../models/api/responses/team.response';
import { ProfileTeam } from '../../models/team.interface';
import { TeamActions } from '../actions/actions-type.action';
import { ProfileStatistics } from '../../../profile/models/api/responses/profileGeneral.response';

export interface ProfilePlayerTeamState {
    currentTeam: ProfileTeam | null;
    tournaments: TeamTournamentsWithPagination | null;
    error: BadResponseWithError | null;
    isLoading: boolean;
    statistics: ProfileStatistics | null;
}

const initialState: ProfilePlayerTeamState = {
    currentTeam: null,
    tournaments: null,
    error: null,
    isLoading: false,
    statistics: null,
};

export const profilePlayerTeamReducer = createReducer(
    initialState,
    on(TeamActions.profileGetTeamInfo, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),
    on(TeamActions.profileGetTeamInfoSuccess, (state, action) => ({
        ...state,
        currentTeam: action.payload,
        isLoading: false,
        error: null,
    })),
    on(TeamActions.profileGetTeamInfoFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    })),
    on(ProfileTeamsActions.profileDeleteTeamSuccess, (state, action) => ({
        ...state,
        currentTeam: null,
        isLoading: false,
        error: null,
    })),
    on(TeamActions.fetchTeamTournaments, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),
    on(TeamActions.fetchTeamTournamentsSuccess, (state, action) => ({
        ...state,
        tournaments: action.payload.patchExistingTournaments
            ? {
                  ...action.payload.response,
                  items: [
                      ...(state.tournaments?.items as Tournament[]),
                      ...action.payload.response.items,
                  ],
              }
            : action.payload.response,
        isLoading: false,
        error: null,
    })),
    on(TeamActions.fetchTeamTournamentsFailure, (state, action) => ({
        ...state,
        currentTeam: null,
        error: action.payload,
        isLoading: false,
    })),
    on(TeamActions.fetchTeamStatistics, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TeamActions.fetchTeamStatisticsSuccess, (state, action) => ({
        ...state,
        statistics: action.payload,
        isLoading: false,
    })),
    on(TeamActions.fetchTeamStatisticsFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    })),
    on(TeamActions.profileInvitePlayerToTeam, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TeamActions.profileInvitePlayerToTeamSuccess, (state) => ({
        ...state,
        isLoading: false,
    })),
    on(TeamActions.profileInvitePlayerToTeamFailure, (state) => ({
        ...state,
        isLoading: false,
    })),
    on(TeamActions.profileTransferLeadership, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TeamActions.profileTransferLeadershipSuccess, (state, action) => ({
        ...state,
        currentTeam: action.payload,
        isLoading: false,
    })),
    on(TeamActions.profileTransferLeadershipFailure, (state) => ({
        ...state,
        isLoading: false,
    })),
    on(TeamActions.profileCancelTeamMemberInvitation, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TeamActions.profileCancelTeamMemberInvitationSuccess, (state) => ({
        ...state,
        isLoading: false,
    })),
    on(TeamActions.profileCancelTeamMemberInvitationFailure, (state) => ({
        ...state,
        isLoading: false,
    })),
    on(TeamActions.profileUpdateTeam, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TeamActions.profileUpdateTeamSuccess, (state, action) => ({
        ...state,
        currentTeam: {
            ...action.payload,
            pendingMembers: state.currentTeam?.pendingMembers,
        },
        isLoading: false,
    })),
    on(TeamActions.profileUpdateTeamFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    })),
    on(TeamActions.profileApplyToJoin, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TeamActions.profileApplyToJoinSuccess, (state, action) => ({
        ...state,
        isLoading: false,
    })),
    on(TeamActions.profileApplyToJoinFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    }))
);
